export enum ProductType {
  Physic = "P",
  Electronic = "E",
  Forward = "F",
  IgnoreProduct = "X",
}
